import { useEffect, useState } from "react";

import { _t } from "@/lib/i18n";
function getRemaining(target) {
  const diff = target - new Date();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, done: false };
}

export default function Countdown({ target, size = "lg", onDone, glow = true, testid }) {
  const targetDate = target instanceof Date ? target : new Date(target);
  const [t, setT] = useState(() => getRemaining(targetDate));

  useEffect(() => {
    const id = setInterval(() => {
      const next = getRemaining(targetDate);
      setT(next);
      if (next.done && onDone) onDone();
    }, 1000);
    return () => clearInterval(id);
  }, [target]); // eslint-disable-line

  const sizes = {
    xs: "text-xl",
    sm: "text-2xl",
    md: "text-4xl",
    lg: "text-5xl md:text-7xl",
  };

  const pad = (n) => String(n).padStart(2, "0");
  const glowClass = glow ? "rocket-glow" : "";

  if (t.done) {
    return (
      <div data-testid={testid || "countdown-ready"} className={`font-mono-launch ${sizes[size]} text-[#4ADE80] ${glowClass}`}>{_t("DECOLLO")}</div>
    );
  }

  return (
    <div data-testid={testid || "countdown"} className={`font-mono-launch ${sizes[size]} text-[#FF5722] ${glowClass} flex items-baseline gap-2 flex-wrap`}>
      <span>{pad(t.d)}<span className="text-xs align-top ml-1 opacity-60">g</span></span>
      <span className="opacity-40">:</span>
      <span>{pad(t.h)}<span className="text-xs align-top ml-1 opacity-60">h</span></span>
      <span className="opacity-40">:</span>
      <span>{pad(t.m)}<span className="text-xs align-top ml-1 opacity-60">m</span></span>
      <span className="opacity-40">:</span>
      <span>{pad(t.s)}<span className="text-xs align-top ml-1 opacity-60">s</span></span>
    </div>
  );
}
